import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { AssignmentLate, AssignmentTurnedIn } from '@mui/icons-material'

import { ContentTrainingMaterialResponse } from '@tabeeb/contracts/microservices/swagger-article-service'

export interface ContentTrainingMaterialListItemProps {
  disabled?: boolean
  item: ContentTrainingMaterialResponse
  onDoubleClick?: (item: ContentTrainingMaterialResponse) => void
}

const ContentTrainingMaterialListItem: React.FC<ContentTrainingMaterialListItemProps> = ({
  children,
  disabled = false,
  item,
  onDoubleClick,
}) => {
  return (
    <ListItemButton key={item.Id} disabled={disabled} disableTouchRipple onDoubleClick={() => onDoubleClick?.(item)}>
      <ListItemIcon>
        {item.Assigned ? (
          item.Read ? (
            <AssignmentTurnedIn color='success' fontSize='medium' />
          ) : (
            <AssignmentLate color='primary' fontSize='medium' />
          )
        ) : (
          <AssignmentLate color='disabled' fontSize='medium' />
        )}
      </ListItemIcon>

      <ListItemText
        primary={item.TrainingMaterial.Name}
        primaryTypographyProps={{ variant: 'subtitle2', title: item.TrainingMaterial.Name, noWrap: true }}
        secondary={item.Assigned ? (item.Read ? 'Read' : 'Unread') : 'Not assigned'}
        secondaryTypographyProps={{
          variant: 'body2',
          fontWeight: 500,
          color: item.Assigned ? (item.Read ? (theme) => theme.palette.success.main : 'primary') : 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          noWrap: true,
        }}
      />

      {children}
    </ListItemButton>
  )
}

export default ContentTrainingMaterialListItem
